import { render, staticRenderFns } from "./SettingsInfo.vue?vue&type=template&id=4fc58fb4&scoped=true&"
import script from "./SettingsInfo.vue?vue&type=script&lang=ts&"
export * from "./SettingsInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc58fb4",
  null
  
)

export default component.exports